export default "__VITE_ASSET__GcOQRIfb__"